// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"409":"2fd090d4","460":"a3b87c8c"}[chunkId] + ".chunk.css";
};